import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

@Injectable({
  providedIn: 'root',
})
export class DesbloquearUsuarioService {
  url: string = environment.apiLocalUrl;

  constructor(private http: HttpClient) {}

  urlparametros: string = `${this.url}parametros/servicios`;

  getTipoDocumentos() {
    return this.http.get(`${this.urlparametros}/tipoDocIdentidad`).pipe(catchError(HandleHttpError));
  }

  getDesbloquearUsuario(idUsuario,idUsuarioRegistro) {
    return this.http.get(
      `${this.url}bancoldex/servicios/administracion/usuario/desbloquear/${idUsuario}/${idUsuarioRegistro}`
    ).pipe(catchError(HandleHttpError));
  }

  getBuscarUsuarios(body: any) {
    return this.http.post(this.url + 'bancoldex/servicios/administracion/usuario/bloqueado/',body).pipe(catchError(HandleHttpError));
  }
}
